import React, {useEffect} from 'react';
import CalendarList from "../components/calendar/calendarList/CalendarList";
import SearchComponent from "../components/searchComponent/SearchComponent";
import {Box, TablePagination, TextField} from "@mui/material";
import CustomSearch from "../components/common/CustomSearch";
import {IGetDoctorsFilter} from "../store/rtk-api/doctor/types";
import {useFormik} from "formik";
import {useAppDispatch, useTypedSelector} from "../store";
import {clearFilterData, setFilterData} from "../store/doctors/doctors.slice";

const Calendar = () => {
    const dispatch = useAppDispatch()
    const {query, is_active} = useTypedSelector(state => state.doctor)
    const formik = useFormik<IGetDoctorsFilter>({
        enableReinitialize: true,
        initialValues: {
            query: query || '',
            is_active: is_active || 'all',
        },
        onSubmit: (values) => {
           // debugger
            dispatch(setFilterData({page: undefined, query: values.query, is_active: values.is_active}))
        }
    })
    const {handleChange, values, handleSubmit, setFieldValue} = formik
    const handleClear = () => {
        dispatch(clearFilterData())
        setFieldValue('query', '')
    }

    // Pagination actions
    const [page, setPage] = React.useState(0);
    useEffect(() => {
        dispatch(setFilterData({page: page + 1}))
    }, [page])

    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const {doctorCount} = useTypedSelector(state => state.calendar)

    const children = (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            <div style={{marginRight: "20px"}}>
                <CustomSearch field={"query"} handleChange={handleChange} placeholder={"Врач, услуга, процедура"}
                              width={"300px"} values={values} handleSubmit={handleSubmit} handleClear={handleClear}/>
            </div>
            {/*<div>*/}
            {/*    <Button variant={"contained"} sx={{height: "40px", backgroundColor:"secondary.main"}}>Обновить</Button>*/}
            {/*</div>*/}
            <div>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={
                        doctorCount || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    sx={{marginBottom: "10px"}}
                />
            </div>
        </Box>
    )
    return (
        <>
            <SearchComponent children={children}/>
            <CalendarList/>
        </>
    );
};

export default Calendar;